import { ServiceStatus as APIServiceStatus } from 'api/domain/entities/Service';

export type ServiceStatus = APIServiceStatus;
export const ServiceStatus = APIServiceStatus;
